import initialState from './memberPaymentTypeInitialState';

export default function memberPaymentTypeReducer(state = initialState) {
    return state;
}
